import { cva, VariantProps } from 'class-variance-authority';

const datePickerVariants = cva('', {
  variants: {
    zSize: {
      sm: 'text-[13px]',
      default: 'text-[14px]',
      lg: 'text-[16px]',
    },
    zType: {
      default: '',
      outline: '',
      ghost: '',
    },
  },
  defaultVariants: {
    zSize: 'default',
    zType: 'outline',
  },
});

export { datePickerVariants };
export type ZardDatePickerVariants = VariantProps<typeof datePickerVariants>;